import * as _ from 'lodash';
import * as moment from "moment";
import { FormEvent, useEffect, useState } from 'react';
import { IDonorSearchResult, IClosedLoopCreateLinks, IListItem } from '@nkr/models/index';
import { ClosedLoopAssignType, DonationType } from '@nkr/enums/index';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock, Badge, Alert, Checkbox, Radio, OverlayTrigger, Popover } from 'react-bootstrap';
import MaskedInput from "react-maskedinput";
import usePrevious from '@nkr/services/use-previous';
import YesNoUnknownRadio, { YesNoUnknown } from '@nkr/components/form/yes-no-unknown-radio';
import { MedicalRecordLinkEmail } from '@nkr/views/donor/add/medical-record-link-email';
import { initialValidation } from '@nkr/views/donor/add/data-model';
interface IProps {
    show: boolean,
    centerId: number,
    type: ClosedLoopAssignType,
    data: IDonorSearchResult,
    isInDonorShield: boolean,
    donationTypes: IListItem[],
    allowVoucherSelfRegistration: boolean,
    onCheckExistingDonor: (alias: string) => Promise<number>,
    onCreate: (
        links: IClosedLoopCreateLinks,
        firstName: string, lastName: string,
        address: string, city: string, state: string, postalCode: string,
        phone: string,
        email: string,
        birthDate: string,
        registrationDate: string,
        donationDate: string,
        donationType: number,
        alias: string,
        hasNutcracker: YesNoUnknown,
        sendInvite: boolean,
        medicalRecordId: number) => Promise<string[]>,
    onCancel: () => void
}

interface IValidation {
    links: boolean,
    firstName: boolean,
    lastName: boolean,
    address: boolean,
    city: boolean,
    state: boolean,
    postalCode: boolean,
    email: boolean,
    phone: boolean,
    birthDate: boolean,
    registrationDate: boolean,
    donationDate: boolean,
    donationType: boolean,
    alias: boolean,
    hasNutcracker: boolean,
    aliasUnique: boolean,
    medicalRecord: boolean
}

const linksInitialState: IClosedLoopCreateLinks = {
    dash: false,
    donor: false,
    donorShieldDirect: false,
    watr: false,
    followUpDonor: false
};

const disabledLinksInitialState: IClosedLoopCreateLinks = {
    dash: false,
    donor: false,
    donorShieldDirect: false,
    watr: false,
    followUpDonor: false
};

const validationInitialState: IValidation = {
    links: true,
    firstName: true,
    lastName: true,
    address: true,
    city: true,
    state: true,
    postalCode: true,
    email: true,
    phone: true,
    birthDate: true,
    registrationDate: true,
    donationDate: true,
    donationType: true,
    alias: true,
    hasNutcracker: true,
    aliasUnique: true,
    medicalRecord: true
};

const Create = (props: IProps) => {
    const [links, setLinks] = useState<IClosedLoopCreateLinks>(linksInitialState);
    const [disabledLinks, setDisabledLinks] = useState<IClosedLoopCreateLinks>(disabledLinksInitialState);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [registrationDate, setRegistrationDate] = useState('');
    const [donationDate, setDonationDate] = useState('');
    const [donationType, setDonationType] = useState(0);
    const [alias, setAlias] = useState('');
    const [hasNutcracker, setHasNutcracker] = useState<YesNoUnknown>(YesNoUnknown.Unknown);
    const [sendSelfRegistrationInvite, setSendSelfRegistrationInvite] = useState(false);
    const [medicalRecordId, setMedicalRecordId] = useState(0);
    const [validation, setValidation] = useState<IValidation>(validationInitialState);
    const [messages, setMessages] = useState<string[]>([]);
    const [dirty, setDirty] = useState(false);

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show) {
            let { type, data } = props;
            let newLinks = { ...linksInitialState };
            let newDisabledLinks = { ...disabledLinksInitialState };

            newDisabledLinks.dash = data != null ? data.registrationId > 0 : false;
            newLinks.dash = type == ClosedLoopAssignType.DASH;

            newDisabledLinks.donor = data != null ? data.donorId > 0 : false;
            newLinks.donor = type == ClosedLoopAssignType.Donor;

            newDisabledLinks.donorShieldDirect = data != null ? data.donorShieldDirectId > 0 || data.donorId > 0 : false;
            newLinks.donorShieldDirect = type == ClosedLoopAssignType.DonorShieldDirect;

            newDisabledLinks.watr = data != null ? data.watrRequestId > 0 || data.donationDate == '' || (data.donorId == 0 && data.donorShieldDirectId == 0 && data.donationDate == '') : false;
            newLinks.watr = type == ClosedLoopAssignType.WaTR;

            newDisabledLinks.followUpDonor = data != null ? data.followUpDonorId > 0 || data.donationDate == '' : false;
            newLinks.followUpDonor = type == ClosedLoopAssignType.FollowUp;
console.log(data);
            setLinks(newLinks);
            setDisabledLinks(newDisabledLinks);
            setFirstName(data != null ? data.firstName : '');
            setLastName(data != null ? data.lastName : '');
            setAddress(data != null ? data.address : '');
            setCity(data != null ? data.city : '');
            setState(data != null ? data.state : '');
            setPostalCode(data != null ? data.postalCode : '');
            setPhone(data != null ? data.phoneNumber : '');
            setEmail(data != null ? data.email : '');
            setBirthDate(data != null ? data.birthDate : '');
            setRegistrationDate(data != null ? data.registrationDate : '');
            setDonationDate(data != null ? data.donationDate : '');
            setAlias(data != null ? data.alias : '');
            setHasNutcracker(data != null ? data.hasNutcracker : YesNoUnknown.Unknown);
            setMedicalRecordId(0);
            setValidation(validationInitialState);
            setMessages([]);
            setDirty(false);
        }
    }, [props.show]);

    const handleLinksChange = (property: string, checked: boolean) => {
        let newLinks = _.cloneDeep(links);
        newLinks[property] = checked;

        let newValidation = { ...validation };

        if (props.isInDonorShield) {
            if (property == 'donor' && checked) {
                links.donorShieldDirect = false;
            }

            if (property == 'donorShieldDirect' && checked) {
                links.donor = false;
            }
        }

        if (dirty) {
            newValidation.links = !links.dash && !links.donor && !links.donorShieldDirect && !links.watr && !links.followUpDonor ? false : true;
        }

        setLinks(newLinks);
        setValidation(newValidation);
    };

    const handleMedicalRecordFieldChange = (name: string, value: any) => {
        if (name == 'email') {
            setEmail(value);
        }

        if (name == 'medicalRecordId') {
            setMedicalRecordId(value);
        }
    };

    const handleNutcrackerChange = (name: string, value: YesNoUnknown) => {
        setHasNutcracker(value);
    }
    const handleChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        let newValidation = _.cloneDeep(validation);

        if (name == 'firstName') {
            setFirstName(value);
        }

        if (name == 'lastName') {
            setLastName(value);
        }

        if (name == 'address') {
            setAddress(value);
        }

        if (name == 'city') {
            setCity(value);
        }

        if (name == 'state') {
            setState(value);
        }

        if (name == 'postalCode') {
            setPostalCode(value);
        }

        if (name == 'email') {
            setEmail(value);
        }

        if (name == 'phone') {
            setPhone(value);
        }

        if (name == 'birthDate') {
            setBirthDate(value);
        }

        if (name == 'registrationDate') {
            setRegistrationDate(value);
        }

        if (name == 'donationDate') {
            setDonationDate(value);
        }

        if (name == 'donationType') {
            setDonationType(parseInt(value));
        }

        if (name == 'alias') {
            setAlias(value);
        }

        if (dirty) {
            switch (name) {
                case 'alias':
                    newValidation.alias = value != '';
                    newValidation.aliasUnique = true;
                    break;

                case 'registrationDate':
                case 'donationDate':
                    newValidation[name] = value != '' ? moment(value).isValid() : true;
                    break;

                case 'birthDate':
                    newValidation[name] = value != '' && moment(value).isValid();
                    break;

                default:
                    newValidation[name] = value != '';
            }

            setValidation(newValidation);
        }
    };

    const handleSendSelfRegistrationChange = (e: FormEvent<Checkbox & HTMLInputElement>) => {
        setSendSelfRegistrationInvite(e.currentTarget.checked);
    };

    const handleCreate = async () => {
        let { newValidation, isValid, existingAlias } = await validate();

        setValidation(newValidation);
        setDirty(true);

        if (isValid) {
            var messages = await props.onCreate(
                links,
                firstName,
                lastName,
                address,
                city,
                state,
                postalCode,
                phone,
                email,
                birthDate,
                registrationDate,
                donationDate,
                donationType,
                alias,
                hasNutcracker,
                sendSelfRegistrationInvite,
                links.donor ? medicalRecordId : 0
            );

            setMessages(messages);
        }
    };

    const validate = async () => {
        let { dash, donor, donorShieldDirect, watr, followUpDonor } = links;

        var existingAlias = alias != '' && donor ? await props.onCheckExistingDonor(alias) : 0;
        
        let newValidation: IValidation = {
            links: !dash && !donor && !donorShieldDirect && !watr && !followUpDonor ? false : true,
            firstName: firstName != '',
            lastName: lastName != '',
            address: address != '',
            city: city != '',
            state: state != '',
            postalCode: postalCode != '',
            email: email != '',
            phone: phone != '',
            birthDate: birthDate != '' && moment(birthDate).isValid(),
            registrationDate: registrationDate != '' ? moment(registrationDate).isValid() : true,
            donationDate: links.followUpDonor ? moment(donationDate).isValid() : true,
            donationType: links.donor ? donationType != 0 : true,
            alias: links.donor ? alias != '' : true,
            aliasUnique: existingAlias == 0,
            hasNutcracker: links.donor ? hasNutcracker != null : true,
            medicalRecord: links.donor ? medicalRecordId != 0 : true,
        };

        let isValid =
            newValidation.links
            && newValidation.firstName && newValidation.lastName
            && newValidation.address && newValidation.city && newValidation.state && newValidation.postalCode
            && newValidation.email && newValidation.phone
            && newValidation.birthDate && newValidation.registrationDate && newValidation.donationDate
            && newValidation.donationType
            && newValidation.alias
            && newValidation.aliasUnique
            && newValidation.hasNutcracker
            && newValidation.medicalRecord
            ;

        return { newValidation, isValid, existingAlias };
    };

    if (props.data == null) {
        return null;
    }

    const { dash, donor, donorShieldDirect, watr, followUpDonor } = links;
    const onlyDonorShieldDirect = !dash && !donor && donorShieldDirect && !watr && !followUpDonor;

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Create Linked Records</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {messages.length > 0 && (
                    <Alert bsStyle='danger' bsSize='sm'>
                        <div style={{ marginBottom: 10 }}>The following issues prevented the creation of the selected linked records...</div>
                        <ul>
                            {messages.map((message, index) =>
                                <li key={index}>{message}</li>
                            )}
                        </ul>
                    </Alert>
                )}

                <FormGroup validationState={validation.links ? null : 'error'}>
                    <ControlLabel>
                        Linked Records to Create
                        {!validation.links && (
                            <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>At least one must be selected</Badge>
                        )}
                    </ControlLabel>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Checkbox inline
                            disabled={disabledLinks.dash}
                            checked={links.dash == true}
                            onChange={(e: React.FormEvent<Checkbox & HTMLInputElement>) => handleLinksChange('dash', e.currentTarget.checked)}>DASH</Checkbox>

                        {props.isInDonorShield ?
                            <>
                                <div style={{ display: 'flex' }}>
                                    <Radio inline
                                        disabled={disabledLinks.donor}
                                        checked={links.donor == true}
                                        onChange={(e: React.FormEvent<Radio & HTMLInputElement>) => handleLinksChange('donor', e.currentTarget.checked)}>Donor</Radio>

                                    <Radio inline
                                        disabled={disabledLinks.donorShieldDirect}
                                        checked={links.donorShieldDirect == true}
                                        onChange={(e: React.FormEvent<Radio & HTMLInputElement>) => handleLinksChange('donorShieldDirect', e.currentTarget.checked)}>DSD</Radio>
                                </div>
                            </>
                            :
                            <Checkbox inline
                                disabled={disabledLinks.donor}
                                checked={links.donor == true}
                                onChange={(e: React.FormEvent<Checkbox & HTMLInputElement>) => handleLinksChange('donor', e.currentTarget.checked)}>Donor</Checkbox>
                        }

                        <Checkbox inline
                            disabled={disabledLinks.watr}
                            checked={links.watr == true}
                            onChange={(e: React.FormEvent<Checkbox & HTMLInputElement>) => handleLinksChange('watr', e.currentTarget.checked)}>Wage &amp; Expenses</Checkbox>

                        <Checkbox inline
                            disabled={disabledLinks.followUpDonor}
                            checked={links.followUpDonor == true}
                            onChange={(e: React.FormEvent<Checkbox & HTMLInputElement>) => handleLinksChange('followUpDonor', e.currentTarget.checked)}>Donor Follow-Up</Checkbox>
                    </div>
                </FormGroup>

                <FormGroup validationState={validation.firstName ? null : 'error'}>
                    <ControlLabel>
                        First Name
                        {!validation.firstName && (
                            <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                        )}
                    </ControlLabel>
                    <FormControl
                        name='firstName'
                        value={firstName}
                        onChange={handleChange}
                    />
                </FormGroup>

                <FormGroup validationState={validation.lastName ? null : 'error'}>
                    <ControlLabel>
                        Last Name
                        {!validation.lastName && (
                            <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                        )}
                    </ControlLabel>
                    <FormControl
                        name='lastName'
                        value={lastName}
                        onChange={handleChange}
                    />
                </FormGroup>

                <FormGroup validationState={validation.address ? null : 'error'}>
                    <ControlLabel>
                        Address
                        {!validation.address && (
                            <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                        )}
                    </ControlLabel>
                    <FormControl
                        name='address'
                        value={address}
                        onChange={handleChange}
                    />
                </FormGroup>

                <div style={{ display: 'flex' }}>
                    <FormGroup style={{ width: '35%', marginRight: 5 }} validationState={validation.city ? null : 'error'}>
                        <ControlLabel>
                            City
                            {!validation.city && (
                                <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                            )}
                        </ControlLabel>
                        <FormControl
                            name='city'
                            value={city}
                            onChange={handleChange}
                        />
                    </FormGroup>

                    <FormGroup style={{ width: '27%', marginRight: 5 }} validationState={validation.state ? null : 'error'}>
                        <ControlLabel>
                            State
                            {!validation.state && (
                                <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                            )}
                        </ControlLabel>
                        <FormControl
                            name='state'
                            value={state}
                            maxLength={2}
                            onChange={handleChange}
                        />
                    </FormGroup>

                    <FormGroup style={{ width: '38%' }} validationState={validation.postalCode ? null : 'error'}>
                        <ControlLabel>
                            Postal Code
                            {!validation.postalCode && (
                                <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                            )}
                        </ControlLabel>
                        <FormControl
                            name='postalCode'
                            value={postalCode}
                            onChange={handleChange}
                        />
                    </FormGroup>
                </div>

                <FormGroup validationState={validation.phone ? null : 'error'}>
                    <ControlLabel>
                        Phone
                        {!validation.phone && (
                            <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                        )}
                    </ControlLabel>
                    <FormControl
                        name='phone'
                        value={phone}
                        onChange={handleChange}
                    />
                </FormGroup>

                {links.donor ?
                    <MedicalRecordLinkEmail
                        centerId={props.centerId}
                        email={email}
                        medicalRecordId={medicalRecordId}
                        validation={{ ...initialValidation, email: validation.email, medicalRecord: validation.medicalRecord }}
                        disabled={false}
                        showMedicalRecord={true}
                        onFieldChange={handleMedicalRecordFieldChange}
                    />
                    :
                    <FormGroup validationState={validation.email ? null : 'error'}>
                        <ControlLabel>
                            Email
                            {!validation.email && (
                                <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                            )}
                        </ControlLabel>
                        <FormControl
                            name='email'
                            value={email}
                            onChange={handleChange}
                        />
                    </FormGroup>
                }

                <div className='row'>
                    <div className='col-xs-12 col-lg-4'>
                        <FormGroup validationState={validation.birthDate ? null : 'error'}>
                            <ControlLabel>
                                Birth Date
                                {!validation.birthDate && birthDate == '' && (
                                    <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                                )}

                                {!validation.birthDate && birthDate != '' && (
                                    <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is not valid</Badge>
                                )}
                            </ControlLabel>
                            <MaskedInput
                                name='birthDate'
                                className='form-control'
                                mask='11/11/1111'
                                placeholder='mm/dd/yyyy'
                                value={birthDate}
                                onChange={handleChange}
                            />
                        </FormGroup>
                    </div>

                    <div className='col-xs-12 col-lg-4'>
                        {(links.dash || links.donor) && (
                            <FormGroup validationState={validation.registrationDate ? null : 'error'}>
                                <ControlLabel>
                                    Registration Date
                                    {!validation.registrationDate && registrationDate != '' && (
                                        <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is not valid</Badge>
                                    )}
                                </ControlLabel>
                                <MaskedInput
                                    name='registrationDate'
                                    className='form-control'
                                    mask='11/11/1111'
                                    placeholder='mm/dd/yyyy'
                                    value={registrationDate}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        )}
                    </div>

                    <div className='col-xs-12 col-lg-4'>
                        {!onlyDonorShieldDirect && (
                            <FormGroup validationState={validation.donationDate ? null : 'error'}>
                                <ControlLabel>
                                    Donation Date
                                    {!validation.donationDate && donationDate == '' && links.followUpDonor && (
                                        <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                                    )}

                                    {!validation.donationDate && donationDate != '' && links.followUpDonor && (
                                        <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is not valid</Badge>
                                    )}
                                </ControlLabel>
                                <MaskedInput
                                    name='donationDate'
                                    className='form-control'
                                    mask='11/11/1111'
                                    placeholder='mm/dd/yyyy'
                                    value={donationDate}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        )}
                    </div>
                </div>

                {links.donor && (
                    <>
                        <FormGroup validationState={validation.donationType ? null : 'error'}>
                            <ControlLabel>
                                Type of Donor
                                {!validation.donationType && (
                                    <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                                )}
                            </ControlLabel>
                            <FormControl
                                componentClass='select'
                                name='donationType'
                                value={donationType}
                                onChange={handleChange}
                            >
                                <option value={0}>- select -</option>
                                {props.donationTypes.map((item, index) => {
                                    //(2 - SV, 3 - NDD, 4 - FV)
                                    if (item.id > 1 && item.id < 5) {
                                        return <option key={'dt-' + index} value={item.id}>{item.description}</option>
                                    }
                                }

                                )}
                            </FormControl>

                            {props.allowVoucherSelfRegistration && (donationType == DonationType.StandardVoucher || donationType == DonationType.FamilyVoucher) && (
                                <Checkbox
                                    className='pull-right'
                                    checked={sendSelfRegistrationInvite}
                                    onChange={handleSendSelfRegistrationChange}>Send self-registration invite to donor</Checkbox>
                            )}
                        </FormGroup>

                        <FormGroup validationState={validation.firstName ? null : 'error'}>
                            <ControlLabel>
                                Alias
                                {!validation.alias && (
                                    <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                                )}

                                {!validation.aliasUnique && (
                                    <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This alias is already in use</Badge>
                                )}
                            </ControlLabel>
                            <FormControl
                                name='alias'
                                value={alias}
                                onChange={handleChange}
                            />
                        </FormGroup>
                        <FormGroup validationState={validation.hasNutcracker ? null : 'error'}>
                            <ControlLabel>
                                Has Nutcracker Syndrome?&nbsp;
                                <OverlayTrigger trigger={['hover', 'click']} placement='right'
                                    overlay={<Popover>Nutcracker syndrome is a rare vascular condition characterized by compression of the left renal vein between the aorta and the superior mesenteric artery causing symptoms. When this anatomical finding does not produce symptoms, it is referred to as Nutcracker Phenomenon.</Popover>}>
                                    <span className='glyphicon glyphicon-info-sign'></span>
                                </OverlayTrigger>

                                {!validation.hasNutcracker && (
                                    <Badge style={{ marginLeft: 5, backgroundColor: '#a94442' }}>This is required</Badge>
                                )}
                            </ControlLabel>
                            <YesNoUnknownRadio
                                name='hasNutcracker'
                                value={hasNutcracker}
                                onChange={handleNutcrackerChange}
                            />
                        </FormGroup>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleCreate}>Create Records</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
    // }
}

export default Create;